<template>
  <v-card flat  class="setup-subtab-content">

    <div class="">

      <div class="font-weight-bold">
        {{ $t('setup.ptaFile') }}
      </div>
      <div>
        <span v-html="$t('setup.ptaInstructions')"></span>
        {{ $t('setup.ptaFormats') }}
        <code>.csv</code>,
        <code>.xlsx</code>, {{ $t('setup.pricelistFormats') }}
        <code>.xls</code>.
      </div>
      <div class="mt-3 mb-2">
        <img
          src="https://docs.unsub.org/~gitbook/image?url=https%3A%2F%2F2329511114-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252FeIwtiPevlQYuy1bQ4x85%252Fuploads%252FEzNuIDspD4tn1v1YlWps%252Fsetup-pta-example-pta-file.png%3Falt%3Dmedia%26token%3D1192b9a6-fe65-49ad-a63f-097ae15f8b84&width=768&dpr=1&quality=100&sign=f7a1c06cf3b54935f82a6dd2ef84fc66&sv=3"
          alt="PTA file example"
          style="max-width: 100%; border: 1px solid #e0e0e0; border-radius: 4px;"
        />
      </div>
      <v-list>
        <publisher-file file-type="perpetualAccess"/>
      </v-list>

    </div>
  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import PublisherFile from "../PulisherFile/PublisherFile";
import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";


export default {
  name: "PublisherSetupTabPta",
  components: {
    PublisherFile,
    PublisherWarning,
  },
  props: {},
  data() {
    return {
      counterFileType: "counter-4",
      isUploadFileLoading: false, // temporary to silence console errors
      fileSelected: null,
      errorMsg: null,


    }
  },
  methods: {},
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "getPublisherDataFile",
      "publisherCounterVersion",
    ]),
  },
  created() {
  },
  mounted() {

  },
  watch: {}
}
</script>

<style lang="scss">


</style>